import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { api } from "../utils/api";

export default function AdminLayout() {
  const [state, setState] = useState({ loading: true, authenticated: false, user: null });
  const location = useLocation();

  useEffect(() => {
    api.session().then(({ data }) => {
      const ok = !!(data && data.ok && data.authenticated);
      setState({ loading: false, authenticated: ok, user: ok ? (data.user || null) : null });
    }).catch(() => setState({ loading: false, authenticated: false, user: null }));
  }, [location.pathname]);

  if (state.loading) {
    return (
      <div className="admin-loading" data-testid="admin-loading">
        <p>Lade Admin-Bereich…</p>
      </div>
    );
  }

  if (!state.authenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet context={{ user: state.user }} />;
}
